import React from 'react';
import PropTypes from 'prop-types';

import icons from './BoxPopularCategoriesIcons';

import 'src/components/BoxPopularCategories.scss';

const BoxPopularCategories = ({
  badge,
  iconName,
  title,
  counter,
  link,
  onClick,
}) => {
  const copy = `${counter} oferty`;
  const Icon = icons[iconName];
  return (
    <a
      data-test="seo-box-categories-tile"
      href={link}
      title={title}
      onClick={onClick}
      styleName="box-popular"
    >
      {badge && <div styleName="box-popular__badge">{badge}</div>}
      <div styleName="box-popular__icon-wrap">
        <Icon styleName="box-icon" />
      </div>
      <div styleName="box-popular__content-wrap box-content">
        <h4 styleName="box-content__title">{title}</h4>
        <span styleName="box-content__counter">{copy}</span>
      </div>
    </a>
  );
};

BoxPopularCategories.defaultProps = { onClick: () => {} };

BoxPopularCategories.propTypes = {
  badge: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  counter: PropTypes.number.isRequired,
  iconName: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default BoxPopularCategories;
